module.exports = __webpack_public_path__ + "static/do_code1-8a1a30ed5a3e771efeabc64f3841efe0.svg";